import React from 'react';
import './IngredientTag.css';

// Close icon (X) as inline SVG
const closeIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23007A33' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E";

function IngredientTag({ ingredient, onRemove }) {
  return (
    <div className="ingredient-tag">
      <span className="ingredient-tag-text">{ingredient}</span>
      <button 
        className="ingredient-tag-remove" 
        onClick={() => onRemove(ingredient)}
        aria-label={`Remove ${ingredient}`}
      >
        <img src={closeIcon} alt="" className="remove-icon" />
      </button>
    </div>
  );
}

export default IngredientTag;
